/**
 * Build the list of cumulative path prefixes for a pathname, used by the two
 * legacy full-breadcrumb Layouts (Inventory, Financial Reports) that render
 * every ancestor segment as a link rather than a single base/mode split (the
 * `splitModePath` shape in src/quotes/modes.ts / src/ads-and-sbs/modes.ts).
 *
 * e.g. "/inventory/parts" -> ["/inventory", "/inventory/parts"]
 *
 * This was previously copy-pasted verbatim (identical `useEffect` block) into
 * both src/inventory/InventoryLayout.tsx and src/financial-reports/index.tsx.
 * Extracted here so there is exactly one implementation; see WP3 recon
 * (recon/A-mode-switchers.md §1) for the drift this was causing.
 */
export function buildPathLinks(pathname: string): string[] {
  const pathLinks: string[] = [];
  const paths = pathname.split("/");
  let pathLinkCount = 0;
  for (let i = 0; i < paths.length; i++) {
    let path = paths[i];
    const previousPath = pathLinks[pathLinkCount - 1] ?? "";
    if (previousPath) {
      path = previousPath + "/" + path;
    } else if (path) {
      path = "/" + path;
    }
    if (path) {
      pathLinks.push(path);
      pathLinkCount++;
    }
  }
  return pathLinks;
}
